<button class="btn btn-primary" type="button" ><i *ngIf="true" class="{{ dmsIcon }}" ></i>{{ dmsTraduction }}</button>